module.exports = __webpack_public_path__ + "static/media/path09.794b04fc.png";